/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_spec_card__detailed_costs__fuel = /** @type {(inputs: {}) => string} */ () => {
	return `Treibstoff`
};

const en_route_spec_card__detailed_costs__fuel = /** @type {(inputs: {}) => string} */ () => {
	return `Fuel`
};

const es_route_spec_card__detailed_costs__fuel = /** @type {(inputs: {}) => string} */ () => {
	return `Combustible`
};

const fr_route_spec_card__detailed_costs__fuel = /** @type {(inputs: {}) => string} */ () => {
	return `Carburant`
};

const it_route_spec_card__detailed_costs__fuel = /** @type {(inputs: {}) => string} */ () => {
	return `Carburante`
};

const nl_route_spec_card__detailed_costs__fuel = /** @type {(inputs: {}) => string} */ () => {
	return `Brandstof`
};

const pt_route_spec_card__detailed_costs__fuel = /** @type {(inputs: {}) => string} */ () => {
	return `Combustível`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__fuel = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_spec_card__detailed_costs__fuel(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_spec_card__detailed_costs__fuel", locale)
	if (locale === "de") return de_route_spec_card__detailed_costs__fuel(inputs)
	if (locale === "en") return en_route_spec_card__detailed_costs__fuel(inputs)
	if (locale === "es") return es_route_spec_card__detailed_costs__fuel(inputs)
	if (locale === "fr") return fr_route_spec_card__detailed_costs__fuel(inputs)
	if (locale === "it") return it_route_spec_card__detailed_costs__fuel(inputs)
	if (locale === "nl") return nl_route_spec_card__detailed_costs__fuel(inputs)
	return pt_route_spec_card__detailed_costs__fuel(inputs)
};